module.exports = __webpack_public_path__ + "img/alchemist-brand.a541ab62.png";